import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

function DeviceManagerPage() {
    return (
        <div>
            <h1>DeviceManager</h1>
            <ul>
                <Link to="/DeviceModels">
                    <button type="button" class="btn btn-primary">Device Model</button>
                </Link>
            </ul>
            <ul>
                <Link to="/DeviceDetails">
                    <button type="button" class="btn btn-primary">Device Detail</button>
                </Link>
            </ul>
        </div>
    );
}

export default DeviceManagerPage;
